<script lang="ts">
  import { getErrorMessage } from '$lib/api/client';
  let { loading = false, error, onRetry, label = 'records' }: { loading?: boolean; error?: unknown; onRetry?: () => unknown; label?: string } = $props();
</script>

{#if loading}
  <div class="tym-card my-3 shrink-0 space-y-4 p-5" role="status" aria-busy="true" aria-label={`Loading ${label}`}>
    <span class="sr-only">Loading {label}…</span>
    {#each [75, 55, 65] as width}<div class="tym-shimmer h-3" style={`width:${width}%`}></div>{/each}
  </div>
{:else if error}
  <div class="tym-card my-3 shrink-0 space-y-3 border-red-200 p-4" role="alert">
    <p class="text-sm text-red-700">Unable to load {label}. {getErrorMessage(error)}</p>
    {#if onRetry}<button type="button" class="btn-secondary" onclick={() => onRetry?.()}>Retry</button>{/if}
  </div>
{/if}
